module.exports = __webpack_public_path__ + "img/cmp_jian.87b525dd.png";